import {
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  HIDE_HEADER_FOOTER,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  message: "این یه تسته",
  hideHeader_footer: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SHOW_MESSAGE: {
      return { ...state, message: action.payload };
    }
    case HIDE_MESSAGE: {
      return { ...state, message: "" };
    }
    case HIDE_HEADER_FOOTER: {
      return { ...state, hideHeader_footer: action.payload };
    }
    default:
      return state;
  }
};
